import { render, staticRenderFns } from "./AccessoryDetail.vue?vue&type=template&id=2697d29e&scoped=true"
import script from "./AccessoryDetail.vue?vue&type=script&lang=js"
export * from "./AccessoryDetail.vue?vue&type=script&lang=js"
import style0 from "./AccessoryDetail.vue?vue&type=style&index=0&id=2697d29e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2697d29e",
  null
  
)

export default component.exports